import { render, staticRenderFns } from "./FormatMenu.vue?vue&type=template&id=7b276874&scoped=true&"
import script from "./FormatMenu.vue?vue&type=script&lang=ts&"
export * from "./FormatMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FormatMenu.vue?vue&type=style&index=0&id=7b276874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b276874",
  null
  
)

export default component.exports